import React, { useEffect } from "react";
import { setBgSrc } from "../const/dom";

const Hero = ({ content }) => {
  useEffect(() => {
    setBgSrc();
    window.reactComplete = true;
  }, []);

  const typeDelay = `^4000`;
  return (
    <section
      className="cover height-100 imagebg text-center"
      data-overlay="5"
      id="hero"
    >
      <div className="background-image-holder">
        <img alt="background" src={content.image} />
      </div>
      <div className="container pos-vertical-center">
        <div className="row">
          <div className="col-md-10">
            <h1 className="typed-headline">
              <span className="block type--bold signatureFont">
                i love to create...
              </span>
              <span
                className="block typed-text typed-text--cursor"
                data-typed-strings={`websites and online experiences. ${typeDelay} ,beautiful code. ${typeDelay} ,stunning interfaces. ${typeDelay},engaging digital content. ${typeDelay}, always every day! ${typeDelay}, using all my versatile skills. ${typeDelay}`}
              ></span>
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
